import React, { useState, useEffect, useRef, Fragment, useCallback, useMemo } from "react";
import LayoutHOC from "../LayoutHOC";
import { Link, useNavigate } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import {
  useFetchHeaderConfigurationQuery,
  usePostFieldCreationMutation,
  usePostFieldDeleteMutation,
  usePostMetaSaveMutation,
} from "../../utils/customer/customerListHeader";

import {
  useFetchAllCustomerValuesQuery,
  useUpdateCustomerTableDataNodeMutation,
  useLazyCustomerTableNodeQuery,
  useLazyFetchPersonInTableQuery,
} from "../../utils/customer/customerTable";

import { useLocation } from "react-router-dom";
import { getUserTokeData } from "../../utils/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Tooltip } from "@mui/material";
import { useSidebar } from "../../components/SidebarContext";
import { pushAlert } from "../../utils/alertSlice";
import CustomerReactTable from "../UniversalComponents/CustomerReactTable";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as ViewNotes } from "../../assets/images/ViewNotes.svg";
import { ReactComponent as TaskToDo } from "../../assets/images/icons/TaskToDo.svg";
import { ReactComponent as DealToDo } from "../../assets/images/icons/Deal.svg";
import { ReactComponent as LeadToDo } from "../../assets/images/icons/LeadToDo.svg";
import { ReactComponent as Recursion } from "../../assets/images/icons/Recursion.svg";
import { ReactComponent as Activity } from "../../assets/images/icons/menu.svg";
import { ReactComponent as LinkTask } from "../../assets/images/icons/Link.svg";
import { ReactComponent as Share } from "../../assets/images/icons/Share.svg";
import { ReactComponent as NewExpandIcon } from "../../assets/images/icons/ExpandIcon.svg";
import { ReactComponent as BlueExpand } from "../../assets/images/icons/BlueExpand.svg";
import {
  checkAccessPermission,
  getCompanyId,
  getIsOwner,
  getOrganizationId,
  getSavedView,
  getUserToken,
} from "../../utils/utilityFunctions/localServices";

import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import { ReactComponent as ViewTask } from "../../assets/images/icons/viewTaskIcon.svg";

import { ReactComponent as AddTask } from "../../assets/images/icons/AddTaskIcon.svg";

import { ReactComponent as DeleteIcon } from "../../assets/images/DeleteIconCustomer.svg";
import ViewNotesDrawer from "../GlobalFeature/Table/ExtraComponent/ViewNotesDrawer";

import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import TasListkModal from "./TasListkModal";

import { ReactComponent as Duplicate } from "../../assets/images/icons/CopyIcon.svg";
import { ReactComponent as NewDuplicate } from "../../assets/images/icons/CopyIcon.svg";
import { ReactComponent as ArchiveIconNew } from "../../assets/images/icons/ArchiveHeaderIcon.svg";
import { ReactComponent as UnSortedIcon } from "../../assets/images/icons/UnSortIcon.svg";
import { ReactComponent as UnArchiveIcon } from "../../assets/images/icons/UnArchiveIcon.svg";

import ManageViewDrawer from "../GlobalFeature/Table/ManageViewDrawer";
import CustomerInfoDrawer from "../company/CustomerInfoDrawer";
import CopyIconComponent from "../UniversalComponents/CopyIconComponent";
import CustomerTablePlusIcon from "../../assets/images/icons/CustomerTablePlusIcon";
import ManageIcon from "../../assets/images/icons/ManageIcon";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import DeleteDialogue from "./DeleteDialogue";
import { ReactComponent as MeetingIcon } from "../../assets/images/icons/MeetingIcon.svg";
import { ReactComponent as GroupIcon } from "../../assets/images/icons/GroupIcon.svg";
import { ReactComponent as ProjectIcon } from "../../assets/images/icons/ProjectIcon.svg";
import { ReactComponent as TaskIcon } from "../../assets/images/icons/TaskIcon.svg";
import { ReactComponent as AppointmentIcon } from "../../assets/images/icons/AppointmentIcon.svg";
import { ReactComponent as ContactIcon } from "../../assets/images/icons/ContactIcon.svg";
import { ReactComponent as DefaultTask } from "../../assets/images/icons/DefaultTask.svg";
import { ReactComponent as ExpandIcon } from "../../assets/images/icons/Expand.svg";
import ArchiveButton from "../UniversalComponents/ArchiveButton";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import List from "../UniversalComponents/ListComponent";
import withPortalHOC from "../UniversalComponents/WithPortalHOC";
import HighlightedParagraph from "../UniversalComponents/HighlightedParagraph";
import AvatarName from "../UniversalComponents/AvatarName";
import {
  formatTextValue,
  formatNegativeNumber,
  getTextAlignment,
  IndeterminateCheckbox,
  safeJsonParse,
} from "../../utils/utilityFunctions/stringUtility";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import ScrollableTabs from "../UniversalComponents/ScrollableTabs";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ReactComponent as NoCustomerData } from "../../assets/images/NoCustomerData.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/images/icons/Archieve.svg";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import ResponsiveTags from "../../utils/utilityFunctions/ResponsiveTags";
import { usePollingWithReset } from "../UniversalComponents/usePollingWithReset";
import CustomerShowDetails from "./CustomerShowDetails";
import AddUserModal from "../User/AddUserModal";
import GetPersonAvatar from "../UniversalComponents/GetPersonAvatar";
import CustomerOtherDetail from "./CustomerOtherDetail";
import { ReactComponent as customerSeperateLine } from "../../assets/images/icons/customerSeprateLine.svg";
import AddItemPlus from "../UniversalComponents/AddItemPlus";
import UniversalCardComponent from "../UniversalComponents/UniversalCardComponent";
import TaskRadioButton from "../UniversalComponents/CompletionCheckbox";
import { NODE_URL } from "../../utils/constants";
import { usePostApiMutation } from "../../utils/customer/customerTaskTable";
import DynamicAddTaskPodModal from "../Task/DynamicAddTaskPodModal";
import { useFetchAllTemplateQuery } from "../../utils/customer/customerSelect";
import {
  buildOptionsFromListCustomerPage,
  generateUniqueValuesForCustomerPage,
} from "../../utils/utilityFunctions/CustomerReactTable/CustomerUtility";

const PortalList = withPortalHOC(List);

const getListData = (data) => {
  const visibleFields = [];
  const hiddenFields = [];

  // Iterate over each field in the flat object
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value.visibility) {
      visibleFields.push(key);
    } else {
      hiddenFields.push(key);
    }
  });

  return { visible_fields: visibleFields, hidden_fields: hiddenFields };
};

const reorderVisibleFields = (listViewData, draggedIndex, targetIndex) => {
  if (
    draggedIndex < 0 ||
    targetIndex < 0 ||
    draggedIndex >= listViewData.visible_fields.length ||
    targetIndex >= listViewData.visible_fields.length
  ) {
    return listViewData; // Return unchanged if indices are invalid
  }

  // Create a copy to prevent mutation
  const updatedVisibleFields = [...listViewData.visible_fields];

  // Remove the dragged item and insert it at the target position
  const [movedItem] = updatedVisibleFields.splice(draggedIndex, 1);
  updatedVisibleFields.splice(targetIndex, 0, movedItem);

  // Return the updated listViewData with new order
  return { ...listViewData, visible_fields: updatedVisibleFields };
};

const updateFieldVisibility = (data, fieldName) => {
  // Deep copy the original data to avoid mutation
  const newData = safeJsonParse(JSON.stringify(data));

  // Iterate through categories and find the matching field name
  for (const category in newData) {
    if (newData.hasOwnProperty(category)) {
      if (newData[category].hasOwnProperty(fieldName)) {
        // Toggle visibility
        newData[category][fieldName].visibility = !newData[category][fieldName].visibility;
        return newData; // Return updated object immediately after modification
      }
    }
  }

  return data; // Return original object if the field is not found
};

const handleFieldVisibilityList = (listViewData, fieldName) => {
  const { visible_fields, hidden_fields } = listViewData;

  // Check if the field is currently visible
  if (visible_fields.includes(fieldName)) {
    // Move from visible → hidden
    return {
      visible_fields: visible_fields.filter((field) => field !== fieldName),
      hidden_fields: [...hidden_fields, fieldName],
    };
  } else {
    // Move from hidden → visible
    return {
      visible_fields: [...visible_fields, fieldName],
      hidden_fields: hidden_fields.filter((field) => field !== fieldName),
    };
  }
};

const getColumnVisibility = (data, alldata) => {
  const columnVisibility = {};

  // 1. Extract existing visibility from `data`
  for (const category in data) {
    if (data.hasOwnProperty(category)) {
      for (const field in data[category]) {
        if (data[category].hasOwnProperty(field)) {
          columnVisibility[field] = data[category][field].visibility;
        }
      }
    }
  }

  // 2. Ensure all fields from `alldata` exist in `columnVisibility`
  alldata?.forEach((item) => {
    if (!columnVisibility?.hasOwnProperty(item?.value)) {
      columnVisibility[item?.value] = false; // Set missing fields to false
    }
  });

  return { ...columnVisibility, groupedColumn: false };
};

const Customer = ({ prop1, prop2 }) => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);
  const [ticker, setTicker] = useState(0);
  const location = useLocation();

  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");
  const taskList = safeJsonParse(localStorage.getItem("taskList"));
  const myUserDataParsed = safeJsonParse(myUserData);

  const parsedCompanyData = safeJsonParse(companyLocalData);

  const { token } = useRequireAuth();

  const [isHovered, setIsHovered] = useState(false);
  const [isMangeHovered, setIsMangeHovered] = useState(false);

  const [activeTab, setActiveTab] = useState("#All");

  const companyId = getCompanyId();
  const [multiData, setMultiData] = useState({});
  const [customerTypes, setCustomerTypes] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTaskDrawerOpen, setIsTaskDrawerOpen] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [taskClickCustomer, setTaskClickCustomer] = useState(null);
  const [viewNotesData, setViewNotesData] = useState(null);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [secondPopupOpen, setSecondPopupOpen] = useState(false);
  const [isArchived, setIsArchived] = useState(false);
  const [showViewList, setShowViewList] = useState(false);
  const [isCreateView, setIsCreateView] = useState(false);
  const [metaData, setMetaData] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState([]);
  const ref = useRef();

  const defaultOrder = [];

  const [columnOrder, setColumnOrder] = useState([]);

  const [totalCount, setTotalCount] = useState("");
  const [leadTypeValue, setLeadTypeValue] = useState("task");
  const [resetPageIndex, setResetPageIndex] = useState(true);

  const [grouping, setGrouping] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isAdvancedFilterOpen, setIsAdvancedFilterOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);
  const [hasPermission, setHasPermission] = useState(checkAccessPermission("Add & Manage Archive Customers"));

  const freshPollingCounter = useRef(0);

  React.useEffect(() => {
    if (grouping.length > 0) {
      setColumnOrder((prevOrder) => {
        // Ensure "groupedColumn" is always at the start
        // const newOrder = ["groupedColumn", ...prevOrder];

        // Remove each grouped column from its previous position
        // grouping.forEach((group) => {
        //   const index = newOrder.indexOf(group);
        //   if (index > 0) {
        //     newOrder.splice(index, 1);
        //   }
        // });

        // Get remaining columns in their original order
        const remainingColumns = defaultOrder.filter((col) => !grouping.includes(col) && col !== "groupedColumn");

        return ["groupedColumn", ...remainingColumns];
      });
    } else {
      // If no grouping exists, restore the original column order
      // setColumnOrder((prevOrder) => prevOrder.filter((col) => col !== "groupedColumn"));
      // setColumnVisibility((prevVisibility) => ({
      //   ...prevVisibility,
      //   groupedColumn: false,
      // }));

      setColumnOrder((prevOrder) => defaultOrder.filter((col) => col !== "groupedColumn"));
    }
    const newVisibility = {};
    grouping?.forEach((group) => {
      newVisibility[group] = false;
    });
    // if (grouping.length == 0) {
    //   newVisibility["groupedColumn"] = false;
    // }

    setColumnVisibility({ ...columnVisibility, ...newVisibility, groupedColumn: grouping.length > 0 });
  }, [grouping]);

  const closeAdvancedFilter = () => {
    setIsAdvancedFilterOpen(false);
  };

  const handleNavigateTasks = (data) => {
    // find the object where label === "deal"
    const dealItem = taskList?.find((item) => item.label === "task");

    if (dealItem) {
      // use the path from that item
      window.open(`/customer/${data}${dealItem.path}`, "_blank");
    } else {
      console.error("No 'deal' label found in activities array.");
    }
  };

  const handleNavigateDeals = (data) => {
    // find the object where label === "deal"
    const dealItem = taskList?.find((item) => item.label === "deal");

    if (dealItem) {
      // use the path from that item
      window.open(`/customer/${data}${dealItem.path}`, "_blank");
    } else {
      console.error("No 'deal' label found in activities array.");
    }
  };

  const handleNavigateLeads = (data) => {
    const dealItem = taskList?.find((item) => item.label === "lead");

    if (dealItem) {
      // use the path from that item
      window.open(`/customer/${data}${dealItem.path}`, "_blank");
    } else {
      console.error("No 'deal' label found in activities array.");
    }
  };

  const openSecondPopup = (taskId, customerId, refetchTaskData) => {
    // console.log("taskIdvinay", taskId);
    let updatedtaskId;
    if (taskId) {
      updatedtaskId = {
        ...taskId,
        assigned_to:
          typeof taskId?.assigned_to === "object" ? taskId?.assigned_to : JSON.parse(taskId?.assigned_to || "{}"),
        start: { value: taskId?.start_date },
        end: { value: taskId?.end_date }, // Parse only if not an object
        tag: taskId?.tag?.map((item) => item.id),
      };
      setTaskId(updatedtaskId);
    } else {
      setTaskId(taskId);
    }

    setSecondPopupOpen({ customerId, refetchTaskData });
  };
  const closeSecondPopup = () => {
    setSecondPopupOpen(false);
  };

  const handleCloseNotes = () => {
    setViewNotesData(false);
  };

  const removeFieldApi = (field) => {
    setFieldToDelete(field);
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    if (fieldToDelete) {
      handleFieldDelete(fieldToDelete);
    }
    setShowConfirmation(false);
    setFieldToDelete(null);
  };

  const TaskCompletionCheckbox = ({ isChecked }) => {
    return (
      <div
        className="flex items-center text-black cursor-pointer"
        // onClick={(e) => handleClickCompleted()}
      >
        <TaskRadioButton isChecked={isChecked} size="small" />
      </div>
    );
  };

  // const TaskToDoImgMatching = {
  //   task: <TaskToDo />,
  //   deal: <DealToDo />,
  //   lead: <LeadToDo />,
  // };
  const TaskToDoConfig = {
    task: {
      icon: <TaskToDo />,
      color: "#984AEA",
    },
    deal: {
      icon: <DealToDo className="h-4 w-4" />,
      color: "#4C53D7",
    },
    lead: {
      icon: <LeadToDo className="h-4 w-4" />,
      color: "#4B9CA5",
    },
  };

  const [view, setView] = useState(getSavedView() ?? { view_name: "Default", view_access: false });
  const [viewList, setViewList] = useState([]);
  const [newViewName, setNewViewName] = useState("");
  const [gridViewData, setGridViewData] = useState([]);
  const [listViewData, setListViewData] = useState([]);

  const user = useSelector((store) => store.user);

  const [menuVisible, setMenuVisible] = useState(false);
  const [isAddFieldOpen, setIsAddFieldOpen] = useState(false);
  const [isDetailsVisible, setDetailsVisible] = useState(false);
  const [isTrackingDialogOpen, setIsTrackingDialogOpen] = useState(false);
  const closeTrackingDialog = () => {
    setIsTrackingDialogOpen(false);
  };
  const [getDelegation, setGetDelegation] = useState(null);
  const [delegationPerson, setDelegationPerson] = useState(null);

  const getPersonAvatar = (personList, header, row) => {
    const toggleDetails = (event, header, row, eachInput) => {
      event.stopPropagation();
      setDetailsVisible((prevState) => !prevState);
      setOpenShowDetails((prev) => !prev);
      setDelegationPerson(eachInput?.id);
      fetchPersonData("");
    };

    return (
      <div className="w-full">
        <div className="pt-1 space-x-1 flex items-end">
          {Array.isArray(personList) &&
            personList
              ?.filter((assigned, index) => index < 3)
              .map((eachInput, index) => {
                const initials = eachInput.name
                  .split(" ")
                  .filter((word) => word.length > 0)
                  .map((word) => word.charAt(0).toUpperCase())
                  .slice(0, 2)
                  .join("");
                const fullName = eachInput.name;

                return (
                  <div key={index} className="relative">
                    <Tooltip
                      title={
                        <>
                          <div className="py-2 min-w-[249px]">
                            <div className="rounded-lg bg-white">
                              <div className="border-b-2 space-y-2 pb-2">
                                <div className="flex px-2 pb-2 border-b-2">
                                  <div>
                                    <AvatarName
                                      name={initials}
                                      size="small"
                                      bgColor={"#E8ECF299"}
                                      textColor={"#7C7C83"}
                                      borderColor={"#ABABAC"}
                                    />
                                  </div>
                                  <div className="text-2999BC text-14">{fullName}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <EmailIcon />
                                  </div>
                                  <div className="text-F16136 text-12">{eachInput?.email}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <PhoneIcon />
                                  </div>
                                  <div className="text-F16136 text-12">
                                    {eachInput.mobile ? eachInput?.mobile : "Not Avaliable"}
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-end mt-2 me-5 text-12">
                                <button
                                  className="text-blue-500"
                                  onClick={(e) => toggleDetails(e, header, row, eachInput)}
                                >
                                  {isDetailsVisible ? "Show more" : "Show more"}
                                </button>
                              </div>
                            </div>
                            <div></div>
                          </div>
                        </>
                      }
                      PopperProps={{ style: { zIndex: 99999 } }}
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "common.white",
                            filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            color: "#383838",
                            "& .MuiTooltip-arrow": {
                              color: "common.white",
                              filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            },
                          },
                        },
                      }}
                    >
                      <div
                        className={` ${eachInput?.c_key ? "text-white border-white" : "text-[#7C7C83] border-[#ABABAC]"} text-12 font-400   p-[10px] w-7 h-7 flex items-center justify-center rounded-full border-[1px]`}
                        style={{ backgroundColor: eachInput?.c_key ? eachInput?.c_key : "#E8ECF2" }}
                      >
                        {initials}
                      </div>
                    </Tooltip>

                    {/* <button
                className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer"
              // onClick={(e) => handleSelectPerson(e, eachInput)} */}
                    {/* >
                &times;
              </button> */}
                  </div>
                );
              })}

          {personList?.length > 3 && (
            <div className="">
              <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300 w-7 h-7 flex items-center justify-center rounded-full border-[1px] ">
                +{personList?.length - 3}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const SingleDelegation = getDelegation?.find((item) => item?.id === delegationPerson);

  const userData = { userUuid: SingleDelegation?.uuid };

  const Data = [userData, "Delegation"];

  const handleMenuToggle = () => {
    setIsCreateView(false);
    setMenuVisible((prev) => !prev);
    setIsAddFieldOpen(false);
  };

  useEffect(() => {
    if (!menuVisible) {
      setIsMangeHovered(false);
    }
  }, [menuVisible]);

  const [
    fetchOptionData,
    { data: optionData, isSuccess: isSuccessOptions, isFetching: isFetchingOptions, isError: isErrorOptions },
  ] = useLazyCustomerTableNodeQuery();

  const handleFetchOptionData = (data) => {
    fetchOptionData({
      token: getUserToken(),
      orgId: getOrganizationId(),
      companyId: getCompanyId(),
      fieldName: data,
    });
  };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token, data: data, companyId: companyId?.company_id });
  };
  useEffect(() => {
    if (personTableData?.data) {
      setGetDelegation(personTableData.data);
    }
  }, [personTableData]);

  //For setting data in Header

  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  useEffect(() => {
    setheaderProps({ name: isArchived ? "Customer Management (Archived)" : "Customer Management" });

    return () => {
      setheaderProps(null);
    };
  }, [setheaderProps, isArchived]);

  const {
    data: customerListHeader,
    refetch: refetchHeader,
    isLoading: headerLoading,
    isError: headerError,
    // } = useFetchCustomerHeaderQuery({
  } = useFetchHeaderConfigurationQuery({
    token: getUserToken(),
    params: {
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      ...(Boolean(view) && { view_name: newViewName ? newViewName : view.view_name }),
    },
  });

  const setDefaultView = () => {
    localStorage.removeItem("saved_view");
    setView({ view_name: "Default", view_access: false });
  };

  const [openViewDeleteDialog, setOpenViewDeleteDialog] = useState(false);

  useEffect(() => {
    if (customerListHeader) {
      if (customerListHeader?.success) {
        if (customerListHeader && customerListHeader?.data?.meta) {
          setMetaData(customerListHeader?.data?.meta);
        }
      } else {
        localStorage.removeItem("saved_view");
        setView({ view_name: "Default", view_access: false });
      }
    }
  }, [customerListHeader]);

  const [postFieldCreation, { isSuccess: isFieldCreationSuccess }] = usePostFieldCreationMutation();

  // useEffect(() => {
  //   if (customerListHeader?.data?.data) {
  //     setGridViewData()
  //   }
  // }, [customerListHeader]);

  const handleTaskClick = (rowData, leadType) => {
    setLeadTypeValue(leadType);
    setTaskClickCustomer(rowData);

    setIsTaskDrawerOpen(true);
  };

  const closeTaskDrawer = () => {
    setIsTaskDrawerOpen(false);
  };
  const [isCustomerDrawerOpen, setIsCustomerDrawerOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);

  const handleCustomerNameClick = (data) => {
    const path = `/customer/${data.id}`;
    window.open(path, "_blank");
  };

  const handleViewNotesClick = (rowData) => {
    setViewNotesData(rowData);
  };
  const getCategoryIcon = (category_id) => {
    switch (category_id) {
      case "Task":
        return <TaskIcon />;
      case "Meeting":
        return <MeetingIcon />;
      case "Call":
        return (
          <div className="w-[15px] h-[15px] rounded-3xl bg-gray-100 flex items-center justify-center">
            <ContactIcon />
          </div>
        );
      case "Appointment":
        return <AppointmentIcon />;
      case "project":
        return <ProjectIcon />;
      case "follow up":
        return <GroupIcon />;

      default:
        return <DefaultTask />; // Return DefaultIcon if no matching category
    }
  };
  function capitalizeWordsWithSpaces(text) {
    return text.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(date);
  };

  //
  const CustomerTableCard = (data, group = false) => {
    return (
      <div className=" pb-2 p-2">
        <div className="flex items-center gap-3  border-b-2 pb-2 w-72">
          <div className="flex  justify-center items-center gap-[22.957px] ">
            <AvatarName
              name={
                (group ? data?.customer_group : data?.customer_display_name)
                  ? (group ? data.customer_group : data.customer_display_name)
                      .split(" ")
                      .splice(0, 2)
                      .map((name) => name[0]?.toUpperCase())
                      .join("")
                  : "N/A"
              }
              size="small"
              bgColor={"#E8ECF299"}
              textColor={"#7C7C83"}
              borderColor={"#ABABAC"}
            />
          </div>
          <div className="text-[#1D4469]  font-poppins text-sm font-medium leading-normal capitalize truncate max-w-[150px]">
            {group ? data?.customer_group : data?.customer_display_name}
          </div>
        </div>
        <div className="flex flex-col gap-2 border-b-2">
          <div className="mt-3 flex items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="">
                <EmailIcon />
              </div>
              <div className="text-[#E95F56] font-poppins text-xs font-normal lowercase max-w-[9rem] truncate">
                {data?.email}
              </div>
            </div>
            <div>
              <CopyIconComponent copyValue={data?.email} />
            </div>
          </div>
          <div
            className="flex items-center justify-between"
            // onClick={() => {
            //   handleCopy(data?.phone);
            // }}
          >
            <div className="flex items-center gap-2 mb-3 justify-center ">
              <div className="h-6 w-6 flex justify-items-center">
                <PhoneIcon />
              </div>
              <div
                className="text-[#2999BC] font-poppins text-xs font-normal lowercase max-w-[8rem] truncate 
"
              >
                {data?.phone}
              </div>
            </div>
            <CopyIconComponent copyValue={data?.phone} />
          </div>
        </div>
        <div className="flex justify-end mt-2 mb-1 text-[#1D4469] font-poppins text-xs font-normal capitalize underline decoration-solid">
          <button className="text-[#1D4469] font-400 inline-block" onClick={() => POPUserDrawer(data, "customer")}>
            Show More
          </button>
        </div>
      </div>
    );
  };
  const TaskCard = (data, customerId, taskType) => {
    const taskData = data?.[`${taskType}_date`];

    return (
      <div className="w-full">
        {/* top section */}
        <div className="px-3 py-2 w-full border-b-2">
          <div className="flex items-center justify-between rounded-[40px]">
            <div className="flex gap-2 items-center justify-center">
              <div
                className="flex items-center px-2 gap-2 py-1 rounded "
                style={{
                  backgroundColor: hexToRgba(TaskToDoConfig[taskType]?.color, 0.06),
                }}
              >
                <div style={{ color: TaskToDoConfig[taskType]?.color }}>{TaskToDoConfig[taskType]?.icon}</div>
                <div
                  className="font-poppins text-sm font-semibold leading-normal capitalize"
                  style={{ color: TaskToDoConfig[taskType]?.color }}
                >
                  {taskType.replace("_", " ")}
                </div>
              </div>
              <div className="h-5 min-w-5 w-fit px-1 py-1 flex items-center justify-center rounded-full bg-[#EE2727] text-white text-center text-xs">
                {taskData?.total_tasks}
              </div>
            </div>
            {/* just for now, because don't know the payload to fetch deal and leads */}

            <div
              onClick={() => {
                handleTaskClick(data, taskType);
              }}
              className="cursor-pointer"
            >
              <ExpandIcon />
            </div>
          </div>
        </div>
        {/* {console.log(taskData, "96543453435434")}; */}

        {/* bottom section */}
        <div className="w-full flex flex-col  ">
          {taskData?.tasks?.map((item, index) => {
            const nameArr = safeJsonParse(item?.assigned_to);

            return (
              <div
                key={index}
                // className={`${index == 0 ? "border-t-1 " : ""} cursor-pointer flex flex-col border-b border-dashed border-[#D2DAE1]  last:border-0 pt-2.5`}
                // style={
                //   index % 2 === 0
                //     ? { borderLeft: `4px solid ${hexToRgba(taskData?.status_color, 0.4)}` }
                //     : { borderRight: `4px solid ${hexToRgba(taskData?.status_color, 0.4)}` }
                // }

                className={`cursor-pointer flex flex-col  last:border-0 ${index === 0 ? "pt-1" : "pt-2.5"}`}
                onClick={() => openSecondPopup(item, customerId)}
              >
                <UniversalCardComponent
                  item={item}
                  nameArr={nameArr}
                  isSecondStyle
                  statusColorCustomer={taskData?.status_color}
                  // onClick={onClick}
                  // isTaskCompleted={isTaskCompleted}
                  TaskCompletionCheckbox={TaskCompletionCheckbox}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const POPUserDrawer = (item, clickedFromCustomerGroup) => {
    setCustomerEditId(item.id);
    setIsCustomerDrawer(clickedFromCustomerGroup);
    // setIsEditMode(false);
    setAddCustomerId(item?.id);

    if (clickedFromCustomerGroup == "customer_group") {
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
    }
  };
  //previous code for refernce , as we need to use scrollable tabs
  //  const TableLeadFilter = () => (
  //   <ul className="flex text-[#848687] font-normal text-center items-center text-base cursor-pointer capitalize mx-6 gap-2 h-full  max-w-[55vw] whitespace-nowrap overflow-x-auto scrollbar-hidden ml-0">
  //     {[{ type: "All" }, ...customerTypes].map((type) => (
  //       <a
  //         // href={`#${type.type}`}
  //         key={type.type}
  //         className={`rounded-md px-4 py-1 text-base font-medium items-center focus:outline-none  ${activeTab === `#${type.type}` ? "text-white bg-[#1D4469]   " : " border border-gray-300 hover:border-[#1D4469] hover:text-[#1D4469]"}`}
  //         onClick={() => handleTabClick(`#${type.type}`)}
  //       >
  //         {type.type}
  //       </a>
  //     ))}
  //   </ul>
  // );

  const TableLeadFilter = () => {
    const scrollRef = useRef(null);
    const tabItems = useMemo(() => [{ type: "All" }, ...customerTypes], [customerTypes]);

    const scroll = (direction) => {
      if (!scrollRef.current) return;
      const scrollAmount = 150;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    };

    const scrollTabRef = useRef(null);

    useEffect(() => {
      if (scrollTabRef.current && activeTab && scrollTabRef.current.scrollIntoView) {
        scrollTabRef.current.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    }, [scrollTabRef]);

    return (
      <div className="relative flex items-center w-full max-w-[60vw]">
        {/* Left Arrow */}
        <button
          className="absolute left-1 z-10 bg-white shadow-md rounded-full p-1 disabled:opacity-30"
          onClick={() => scroll("left")}
        >
          <ChevronLeft size={20} />
        </button>

        {/* Scrollable Tab List */}
        <ul
          ref={scrollRef}
          className="flex text-[#848687] font-normal text-center items-center text-base cursor-pointer capitalize gap-2 h-full whitespace-nowrap overflow-x-auto scrollbar-hidden mx-8"
        >
          {tabItems?.map((type) => (
            <a
              ref={activeTab === `#${type.type}` ? scrollTabRef : null}
              key={type.type}
              className={`rounded-md px-4 py-1 text-base font-medium items-center focus:outline-none ${
                activeTab === `#${type.type}`
                  ? "text-white bg-[#1D4469]"
                  : "border border-gray-300 hover:border-[#1D4469] hover:text-[#47637D]"
              }`}
              onClick={() => handleTabClick(`#${type.type}`)}
            >
              {type.type}
            </a>
          ))}
        </ul>

        {/* Right Arrow */}
        <button
          className="absolute right-1 z-10 bg-white shadow-md rounded-full p-1 disabled:opacity-30"
          onClick={() => scroll("right")}
        >
          <ChevronRight size={20} />
        </button>
      </div>
    );
  };

  const [addCustomerId, setAddCustomerId] = useState("");
  const [editCustomerOpen, setEditCustomerOpen] = useState(false);
  const [CustomerEditId, setCustomerEditId] = useState();
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [deleteCustomerOpen, setDeleteCustomerOpen] = useState(false);
  const [CustomerDeleteId, setCustomerDeleteId] = useState();
  const [archiveCustomerOpen, setArchiveCustomerOpen] = useState(false);
  const [CustomerArchiveId, setCustomerArchiveId] = useState();
  const [openShowDetails, setOpenShowDetails] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [detaillOpen, setDetaillOpen] = useState(false);
  // const handleRowSelection = (event, rowId, index, tableData) => {
  //   event.stopPropagation();

  //   const currentIndex = index;

  //   // Update MultiData
  //   setMultiData((prev) => {
  //     const newSelectedRows = { ...prev };

  //     setSelectedRowId((prevIds) => {
  //       let updatedIds = [...prevIds];

  //       if (event.shiftKey && lastSelectedRowIndex !== null) {
  //         const lower = Math.min(lastSelectedRowIndex, currentIndex);
  //         const upper = Math.max(lastSelectedRowIndex, currentIndex);

  //         for (let i = lower; i <= upper; i++) {
  //           const strIndex = i.toString();
  //           const rowAtI = tableData.getRowModel().rows[i];
  //           const idAtI = rowAtI?.original?.id;

  //           if (!updatedIds.includes(strIndex)) {
  //             updatedIds.push(strIndex);
  //           }

  //           if (idAtI) newSelectedRows[idAtI] = true;
  //         }
  //       } else {
  //         const strIndex = currentIndex.toString();
  //         const id = rowId;

  //         if (updatedIds.includes(strIndex)) {
  //           updatedIds = updatedIds.filter((val) => val !== strIndex);
  //           delete newSelectedRows[id];
  //         } else {
  //           updatedIds.push(strIndex);
  //           newSelectedRows[id] = true;
  //         }
  //       }

  //       return updatedIds;
  //     });

  //     setLastSelectedRowIndex(currentIndex);
  //     return newSelectedRows;
  //   });
  // };

  const handleCustomerEdit = (data) => {
    setIsCustomerDrawer(true);
    setIsEditMode(true);
    setIsDuplicate(true);
    setAddCustomerId(data?.id);
    setCustomerEditId(data?.id);
    setEditCustomerOpen((prev) => !prev);
  };

  const handleCustomerDelete = (data) => {
    setCustomerDeleteId(data);
    setDeleteCustomerOpen((prev) => !prev);
  };

  const handleCustomerArchive = (data) => {
    setCustomerArchiveId(data);
    setArchiveCustomerOpen((prev) => !prev);
  };

  const closeDeleteDrawer = () => {
    setDeleteCustomerOpen(false);
  };

  const closeArchiveDrawer = () => {
    setArchiveCustomerOpen(false);
  };

  // const [lastSelectedRowId, setLastSelectedRowId] = useState(null);

  // const handleRowSelection = (event, rowId, index,table) => {

  //   setMultiData((prev) => {
  //     const newSelectedRows = { ...prev };

  //     if (newSelectedRows[rowId]) {
  //       delete newSelectedRows[rowId];
  //     } else {
  //       newSelectedRows[rowId] = true;
  //     }

  //     return newSelectedRows;
  //   });
  // };

  const [lastSelectedRowIndex, setLastSelectedRowIndex] = useState(null);

  const handleRowSelection = (event, rowId, index, tableData) => {
    //const checkindex=tableData.getRowModel().rows.findIndex((item)=>item.original.id==rowId)

    setMultiData((prev) => {
      let newSelectedRows = { ...prev };
      let currentIndex;
      tableData.getRowModel().rows.map((item, index) => {
        if (item.original.id === rowId) {
          currentIndex = index;
        }
      });

      setLastSelectedRowIndex((prevLastIndex) => {
        if (event.shiftKey && prevLastIndex !== null) {
          const lowerIndex = Math.min(prevLastIndex, currentIndex);
          const upperIndex = Math.max(prevLastIndex, currentIndex);

          for (let i = lowerIndex; i <= upperIndex; i++) {
            newSelectedRows[tableData.getRowModel().rows[i]?.original?.id] = true;
          }
        } else {
          if (newSelectedRows[rowId]) {
            delete newSelectedRows[rowId];
          } else {
            newSelectedRows[rowId] = true;
          }
        }

        return currentIndex;
      });

      return newSelectedRows;
    });
  };

  const jsonStringFilter = (row, columnId, filterValue) => {
    //const cellValue = JSON.stringify(row.getValue(columnId) || ""); // Convert to string

    const cellValue = row.getValue(columnId); // Convert to string

    // return cellValue.toLowerCase().includes(filterValue.toLowerCase());

    return filterValue.every((filterStr) =>
      cellValue?.some((person) => person.email?.toLowerCase().includes(filterStr?.toLowerCase()))
    );
  };

  const customFilterFn = (row, columnId, filterValue) => {
    let rawValue = row.getValue(columnId);
    let cellValues = [];

    try {
      const parsed = typeof rawValue === "string" ? safeJsonParse(rawValue) : rawValue;

      if (Array.isArray(parsed)) {
        cellValues = parsed
          .filter((item) => item && typeof item === "object")
          .map((item) => {
            return (item.value ?? item.email)?.toString().toLowerCase() ?? "";
          });
      } else if (parsed && typeof parsed === "object") {
        if (columnId === "delegations" && "email" in parsed) {
          cellValues = [parsed.email?.toString().toLowerCase() ?? ""];
        } else if ("value" in parsed) {
          cellValues = [parsed.value?.toString().toLowerCase() ?? ""];
        }
      } else {
        cellValues = [parsed?.toString().toLowerCase() ?? ""];
      }
    } catch (e) {
      cellValues = [rawValue?.toString().toLowerCase() ?? ""];
    }

    const keyword = filterValue?.keyword?.toString().toLowerCase() ?? "";
    const condition = filterValue?.condition;

    switch (condition) {
      case "Is":
        return cellValues.some((val) => val === keyword);
      case "Isn't":
        return cellValues.every((val) => val !== keyword);
      case "Contains":
        return cellValues.some((val) => val.includes(keyword));
      case "Doesn't Contain":
        return cellValues.every((val) => !val.includes(keyword));
      case "StartsWith":
        return cellValues.some((val) => val.startsWith(keyword));
      case "EndsWith":
        return cellValues.some((val) => val.endsWith(keyword));
      case "IsEmpty":
        return cellValues.every((val) => val.trim() === "");
      case "IsNotEmpty":
        return cellValues.some((val) => val.trim() !== "");
      default:
        return true;
    }
  };

  function columnFilterForPageData(row, columnId, filterValue) {
    if (columnId === "delegation") console.log("filterValue", filterValue, columnId);

    // No filter -> show row
    if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;

    const safeParse = (s) => {
      if (typeof s !== "string") return null;
      try {
        return JSON.parse(s);
      } catch {
        return null;
      }
    };

    const normalize = (v) => {
      if (v === null || v === undefined) return "";
      return String(v).trim().toLowerCase();
    };

    // Extract tokens (normalized strings) from an entry of many shapes
    const extractTokens = (entry) => {
      if (entry == null) return [];

      // primitive (string/number/boolean)
      if (["string", "number", "boolean"].includes(typeof entry)) {
        // if string may be JSON, try parse and recurse
        if (typeof entry === "string") {
          const parsed = safeParse(entry);
          if (parsed && typeof parsed === "object") return extractTokens(parsed);
        }
        return [normalize(entry)];
      }

      // array -> flatten inner tokens
      if (Array.isArray(entry)) {
        const acc = [];
        for (const inner of entry) {
          if (inner == null) continue;
          if (["string", "number", "boolean"].includes(typeof inner)) {
            acc.push(normalize(inner));
            continue;
          }
          if (typeof inner === "object") {
            // inner object: prefer these keys (order matters)
            const pick =
              inner.value ??
              inner.id ??
              inner.label ??
              inner.email ??
              inner.name ??
              inner.textForUrl ??
              inner.url ??
              null;
            if (pick != null) {
              // if pick is stringified JSON, recurse
              if (typeof pick === "string") {
                const p = safeParse(pick);
                if (p && typeof p === "object") {
                  acc.push(...extractTokens(p));
                } else {
                  acc.push(normalize(pick));
                }
              } else {
                acc.push(normalize(pick));
              }
              continue;
            }
            // fallback: pick first primitive prop on inner
            const primKey = Object.keys(inner).find((k) => ["string", "number", "boolean"].includes(typeof inner[k]));
            if (primKey) acc.push(normalize(inner[primKey]));
            else {
              try {
                acc.push(normalize(JSON.stringify(inner)));
              } catch {}
            }
          }
        }
        return acc.filter(Boolean);
      }

      // object -> extract best token(s)
      if (typeof entry === "object") {
        // 1) prefer id
        if (entry.id !== undefined && entry.id !== null) return [normalize(entry.id)];

        // 2) wrapper with value
        if (Object.prototype.hasOwnProperty.call(entry, "value")) {
          const v = entry.value;
          // primitive -> token
          if (["string", "number", "boolean"].includes(typeof v)) {
            // if string might be JSON
            if (typeof v === "string") {
              const parsed = safeParse(v);
              if (parsed && typeof parsed === "object") return extractTokens(parsed);
            }
            return [normalize(v)];
          }
          // array -> recurse
          if (Array.isArray(v)) return extractTokens(v);
          // object -> prefer inner fields
          if (typeof v === "object" && v !== null) {
            const innerPick = v.value ?? v.textForUrl ?? v.url ?? v.label ?? v.email ?? v.name ?? v.id ?? null;
            if (innerPick != null) return Array.isArray(innerPick) ? innerPick.map(normalize) : [normalize(innerPick)];
            // else try deeper
            return extractTokens(v);
          }
        }

        // 3) direct person/choice/object fields
        const pick = entry.value ?? entry.label ?? entry.email ?? entry.name ?? entry.textForUrl ?? entry.url ?? null;
        if (pick != null) {
          if (typeof pick === "string") {
            const parsed = safeParse(pick);
            if (parsed && typeof parsed === "object") return extractTokens(parsed);
            return [normalize(pick)];
          }
          if (["number", "boolean"].includes(typeof pick)) return [normalize(pick)];
          if (Array.isArray(pick) || typeof pick === "object") return extractTokens(pick);
        }

        // 4) fallback: first primitive prop
        for (const k of Object.keys(entry)) {
          const v = entry[k];
          if (["string", "number", "boolean"].includes(typeof v)) return [normalize(v)];
        }

        // 5) ultimate fallback: stringify small preview
        try {
          return [normalize(JSON.stringify(entry))];
        } catch {
          return [];
        }
      }

      return [];
    };

    if (columnId === "delegation") {
      // show all if nothing selected
      if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;

      const normalize = (s) => (s == null ? "" : String(s).trim().toLowerCase());

      // build set of selected emails from filterValue (array of objects)
      const selectedEmails = new Set();
      const fvArr = Array.isArray(filterValue) ? filterValue : [filterValue];
      for (const sel of fvArr) {
        if (!sel) continue;
        // common shapes: { email }, or { value: { email } }, or maybe { email_address }
        const email =
          (typeof sel === "object" &&
            (sel.email || sel.email_address || sel.value?.email || sel.value?.email_address)) ||
          (typeof sel === "string" && sel) ||
          null;
        if (email) selectedEmails.add(normalize(email));
      }

      if (selectedEmails.size === 0) return true;

      // extract emails present in the row cell (expected to be array of person objects)
      const cell = row.getValue(columnId);
      if (!Array.isArray(cell)) return false; // defensive: if not array, no match

      const cellEmails = new Set();
      for (const person of cell) {
        if (!person) continue;
        const em = person.email ?? person.email_address ?? person.emailAddress ?? null;
        if (em) cellEmails.add(normalize(em));
      }

      // AND semantics: every selected email must appear in cellEmails
      for (const selEmail of selectedEmails) {
        if (!cellEmails.has(selEmail)) return false;
      }
      return true;
    }

    // Build selected set from filterValue (can be array or single)
    const selectedSet = new Set();
    const fvArr = Array.isArray(filterValue) ? filterValue : [filterValue];
    for (const fv of fvArr) {
      const tokens = extractTokens(fv);
      for (const t of tokens) if (t) selectedSet.add(t);
    }

    // get tokens from the row cell
    const cell = row.getValue(columnId);
    const cellTokens = extractTokens(cell);

    // OR semantics: any token match
    for (const token of cellTokens) {
      if (selectedSet.has(token)) return true;
    }
    return false;
  }

  const multiSelectFilterFn = (row, columnId, filterValue) => {
    // If no filter is applied, return true (i.e. show the row)
    if (!filterValue || filterValue.length === 0) return true;
    // Check if the row value is included in the selected values
    return filterValue.includes(row.getValue(columnId));
  };

  const columns = useMemo(() => {
    const staticColumn = [
      ...(grouping.length === 0
        ? [
            {
              id: "select",
              header: ({ table }) => {
                const allRows = table.getRowModel().rows;
                const allRowIds = allRows.map((row) => row.original.id);

                const allSelected = allRowIds?.every((id) => multiData[id]);
                const someSelected = allRowIds?.some((id) => multiData[id]);

                return (
                  <IndeterminateCheckbox
                    {...{
                      checked: allSelected,
                      indeterminate: someSelected && !allSelected,
                      onChange: (e) => {
                        if (e.target.checked) {
                          setLastSelectedRowIndex(null);
                          setMultiData((prev) => ({
                            ...prev,
                            ...Object.fromEntries(allRowIds.map((id) => [id, true])),
                          }));
                        } else {
                          setLastSelectedRowIndex(null);
                          setMultiData((prev) => {
                            const updated = { ...prev };
                            allRowIds.forEach((id) => delete updated[id]);
                            return updated;
                          });
                        }
                      },
                    }}
                  />
                );
              },
              cell: ({ row, table }) => {
                return (
                  <div className=" flex items-center justify-center">
                    <IndeterminateCheckbox
                      {...{
                        checked: multiData[row.original.id],
                        disabled: !row.getCanSelect(),
                        indeterminate: row.getIsSomeSelected(),
                        onClick: (e) => handleRowSelection(e, row.original.id, row.index, table),
                      }}
                    />
                    {(checkAccessPermission("Customer Relationship") || getIsOwner()) && (
                      <button
                        className="delete-button text-primary"
                        onClick={() => setIsTrackingDialogOpen(row.original.id)}
                      >
                        <ToolTipComponent darkMode text="Expand" textOnly>
                          <BlueExpand className="fill-current" />
                        </ToolTipComponent>
                      </button>
                    )}
                  </div>
                );
              },
            },
          ]
        : []),
      {
        id: "groupedColumn",
        header: ({ table }) =>
          grouping.length > 1
            ? "Group"
            : table
                .getAllColumns()
                .filter((col) => col.columnDef.accessorKey === grouping[0])
                .map((col) => col.columnDef.header)[0] || grouping[0],
        cell: () => null,
      },
    ];

    const dynamicColumns =
      customerListHeader?.data?.data?.map((header) => ({
        accessorKey: header.value, // Use value key for accessorKey
        header: header.label, // Use label key for header
        meta: { position: "left", filterVariant: "select", type: header?.type, ...header?.meta }, // Add meta with default position
        // enableFiltering: false,
        // filterVariant: "select",
        // ...(header.value=="notes" && {enableColumnFilter: false}),

        ...(isAdvancedFilterOpen ? { filterFn: customFilterFn } : { filterFn: columnFilterForPageData }),

        ...([].includes(header.value) && { enableColumnFilter: false }),

        sortUndefined: "1", // Disable filtering by default
        cell: (info) => {
          const value = info.getValue();
          const { separators, decimalPlaces, negativeFormat, selectedOption, symbol } =
            header?.meta?.numberFormat || {};
          const { textSelectedOption } = header?.meta?.textFormat || {};

          if (header?.value === "delegation") {
            return (
              <p className="w-fit max-w-[10vw]">
                <GetPersonAvatar
                  personList={value}
                  header={header}
                  rowKey={info.row.original?.id}
                  isDetailsVisible={isDetailsVisible}
                  setDetailsVisible={setDetailsVisible}
                />
              </p>
            );
          }
          if (["person", "multi_person"].includes(header?.type)) {
            return (
              <p className="w-fit max-w-[10vw]">
                <GetPersonAvatar
                  personList={safeJsonParse(value)}
                  header={header}
                  rowKey={info.row.original?.id}
                  isDetailsVisible={isDetailsVisible}
                  setDetailsVisible={setDetailsVisible}
                />
              </p>
            );
          }
          if (header.type === "task_template") {
            const data = info.row.original;
            const key = header?.task_template_key;
            const { [key]: tasks, id: customerId } = data;

            if (!tasks || !tasks?.tasks) {
              return (
                <div className="flex justify-end delete-button">
                  <ToolTipComponent disableInteractive darkMode text={<>{`Add ${header.value}`}</>}>
                    <div
                      onClick={() => {
                        setLeadTypeValue(header.value === "tasks" ? "task" : header.value);
                        setTaskClickCustomer({ customer_name: data?.customer_name, id: customerId, data: data });
                        openSecondPopup(null, { customer_name: data?.customer_name, customer_id: customerId });
                      }}
                      className="text-primary"
                    >
                      <AddTask width="14px" height="14px" className="fill-current" />
                    </div>
                  </ToolTipComponent>
                </div>
              );
            }

            const dateObj = new Date(tasks?.tasks[0]?.start_date);
            const formattedDate = dateObj.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            });

            return (
              <>
                <div className="flex items-center justify-between gap-1">
                  <ToolTipComponent
                    text={TaskCard(data, customerId, header.value === "tasks" ? "task" : header.value)}
                    height="160px"
                    offset="right"
                    style={{ padding: "0px", width: "350px" }}
                    // open={true}
                  >
                    <p
                      className="px-2 py-1 rounded border min-w-[4rem] text-center"
                      style={{
                        borderRadius: "5px",
                        backgroundColor: hexToRgba(tasks?.status_color, 0.12),
                        color: tasks?.status_color,
                        border: "1px solid transparent",
                        boxShadow: `inset 0px 1px 0px 0px ${hexToRgba(tasks?.status_color, 0.8)}`,
                      }}
                      onClick={() => handleNavigateTasks(customerId)}
                    >
                      {formattedDate}
                    </p>
                  </ToolTipComponent>
                  {/* <p className="px-2 py-1 rounded text-white" style={{ backgroundColor: tasks?.status_color }} onClick={() => (TaskCard(data, customerId))}>
                    {formattedDate}
                  </p> */}

                  <ToolTipComponent darkMode text={`View ${header.value}`} textOnly>
                    <span
                      className="delete-button block text-primary"
                      onClick={() =>
                        handleTaskClick(info.row.original, header.value === "tasks" ? "task" : header.value)
                      }
                    >
                      <ViewTask width="14px" height="14px" className="fill-current" />
                    </span>
                  </ToolTipComponent>
                </div>
              </>
            );
          }

          if (header.value === "customer_name") {
            return (
              <div className="flex justify-between overflow-hidden text-ellipsis gap-3">
                <div className="overflow-hidden text-ellipsis cursor-pointer">
                  <ToolTipComponent
                    // open={true}
                    text={CustomerTableCard(info.row.original)}
                    height={"120px"}
                    placement={"right-start"}
                    style={{ minWidth: "230px" }}
                    // open={true}
                  >
                    <p
                      style={{ color: "var(--color-primary)", fontWeight: 500 }}
                      onClick={() => {
                        handleCustomerNameClick(info.row.original);
                      }}
                      className="overflow-hidden text-ellipsis hover:underline"
                    >
                      <HighlightedParagraph paragraph={value} searchTerm={globalFilter} />
                    </p>
                  </ToolTipComponent>
                </div>
                {!isArchived && (
                  <div className=" gap-2 customer-button">
                    {checkAccessPermission("Add & Manage Archive Customers") && (
                      <button
                        className=""
                        onClick={() => {
                          handleCustomerDelete(info.row.original);
                        }}
                      >
                        <ToolTipComponent darkMode text="Delete" textOnly>
                          <DeleteIcon />
                        </ToolTipComponent>
                      </button>
                    )}
                    <button
                      className=""
                      onClick={() => {
                        handleCustomerEdit(info.row.original);
                      }}
                    >
                      <ToolTipComponent darkMode text="Duplicate" textOnly>
                        <span className="text-primary">
                          <NewDuplicate className="fill-current" />
                        </span>
                      </ToolTipComponent>
                    </button>
                    {checkAccessPermission("Add & Manage Archive Customers") && (
                      <button
                        onClick={() => {
                          handleCustomerArchive(info.row.original);
                        }}
                      >
                        <ToolTipComponent darkMode text="Archive" textOnly>
                          <span className="text-primary">
                            <ArchiveIconNew className="fill-current" />
                          </span>
                        </ToolTipComponent>
                      </button>
                    )}
                  </div>
                )}

                {isArchived && (
                  <div className=" gap-3 customer-button">
                    <button
                      className=""
                      onClick={() => {
                        handleCustomerArchive(info.row.original);
                      }}
                    >
                      <ToolTipComponent text="UnArchive" textOnly>
                        <UnArchiveIcon />
                      </ToolTipComponent>
                    </button>
                  </div>
                )}
              </div>
            );
          }
          if (header.value === "customer_group") {
            return (
              <ToolTipComponent
                text={CustomerTableCard(info.row.original, true)}
                height={"120px"}
                placement={"right"}
                style={{ minWidth: "230px" }}
              >
                <div
                  className="text-primary cursor-pointer font-medium hover:underline"
                  onClick={() => {
                    POPUserDrawer(info.row.original, "customer_group");
                  }}
                >
                  {info.getValue()}
                </div>
              </ToolTipComponent>
            );
          }

          if (header.value === "notes") {
            return (
              <p onClick={() => handleViewNotesClick(info.row.original)}>
                {value > 0 ? (
                  <div className="flex items-center gap-1 min-w-fit">
                    <ToolTipComponent darkMode text="View Notes" textOnly>
                      <span className="text-primary">
                        <ViewNotes className="hover:fill-current fill-[#969BA9] cursor-pointer" />
                      </span>
                    </ToolTipComponent>
                    {value > 0 && <span style={{ fontSize: "12px", color: "#666" }}>({value})</span>}
                  </div>
                ) : (
                  <span className="font-600 text-">-</span>
                )}
              </p>
            );
          }

          try {
            const parsedValue = typeof value === "string" ? safeJsonParse(value) : value;
            if (Array.isArray(parsedValue)) {
              return <ResponsiveTags parsedValue={parsedValue} />;
            }

            if (typeof parsedValue === "object" && parsedValue?.value) {
              const rgbaColor = parsedValue?.color_code || parsedValue?.code ? `${parsedValue.color_code}` : undefined;
              return (
                <p
                  className={`${rgbaColor && "px-2 py-1"} rounded  text-ellipsis overflow-hidden w-fit max-w-full`}
                  style={{
                    backgroundColor: hexToRgba(rgbaColor, 0.1),
                    color: rgbaColor ? hexToRgba(rgbaColor) : "black",
                    borderRadius: "5px",
                    border: rgbaColor ? `0.8px solid ${rgbaColor}` : "none",
                  }}
                >
                  {parsedValue.value}
                </p>
              );
            }
          } catch (error) {}

          //return <p className="w-fit max-w-[10vw] text-ellipsis overflow-hidden ">{HighlightedParagraph(value,globalFilter)}</p>;
          return (
            <HighlightedParagraph
              paragraph={
                header?.type === "number"
                  ? formatNegativeNumber(value, negativeFormat, selectedOption, decimalPlaces, separators, symbol)
                  : header?.type === "text"
                    ? formatTextValue(value, textSelectedOption)
                    : header?.type === "date"
                      ? getUserDateTime(value)
                      : value
              }
              // metaInfo={header?.type==="number"? header.meta : {}}
              searchTerm={globalFilter}
              className={`w-full text-ellipsis overflow-hidden truncate text-primary-text`}
              style={{ textAlign: getTextAlignment(header?.type) }}
            />
          );
        },
      })) || [];

    return [...staticColumn, ...dynamicColumns];
  }, [customerListHeader, grouping, isArchived, multiData, globalFilter, isAdvancedFilterOpen]);

  const handleUpdateHeader = (data) => {
    if (customerListHeader?.data?.active_template) {
      setListViewData(getListData(customerListHeader?.data?.active_template.fields));
      const gridData = customerListHeader?.data?.all_templates.filter(
        (item) => item.view_name === customerListHeader.data.active_template.name
      )[0]?.fields;
      setGridViewData(gridData);
      setColumnVisibility(getColumnVisibility(gridData, customerListHeader?.data.data));

      let viewNames = customerListHeader?.data?.all_templates.map((item) => ({
        view_name: item.view_name,
        view_access: item.is_group_view,
        groupIds: item.assigned_group_ids,
      }));
      setViewList(viewNames);
      if (newViewName) {
        const tempView = viewNames.filter((item) => item.view_name === newViewName)[0];
        localStorage.setItem("saved_view", JSON.stringify(tempView));
        setView(tempView);
      }
      // let activeView = viewNames.filter((item) => item.view_name === customerListHeader.data.active_template.name);
      // setView(activeView[0]);
    }
  };

  useEffect(() => {
    handleUpdateHeader();
  }, [customerListHeader]);

  const [refetchBytask, setRefetchByTask] = useState(false);

  const {
    data: AllCustomerData,
    refetch: refetchCustomerDataNodeOnly,
    isFetching: customerFetching,
    isLoading: customerLoading,
    isError: customerError,
  } = useFetchAllCustomerValuesQuery({
    token: token,
    orgId: myUserDataParsed?.org_id,
    companyId: parsedCompanyData.company_id,
    limit: 1000,
    // viewName: "Universal",
    type: activeTab.replace("#", ""),
    isArchived: isArchived,
  });

  const refetchCustomerDataNode = useCallback(() => {
    freshPollingCounter.current = 0;
    refetchCustomerDataNodeOnly();
  }, [refetchCustomerDataNodeOnly, freshPollingCounter]);

  const refetchPollingData = () => {
    freshPollingCounter.current += 1;
    refetchCustomerDataNodeOnly();
  };

  usePollingWithReset(refetchPollingData, [AllCustomerData], 10000, true, "customer Repolled");

  useEffect(() => {
    refetchCustomerDataNode();
  }, [activeTab, isArchived, refetchBytask]);

  useEffect(() => {
    if (AllCustomerData) {
      const types = AllCustomerData?.data?.type_counts || [];
      const filteredTypes1 = Object.keys(types || {})?.map((key) => ({ type: key }));
      const filteredTypes = filteredTypes1.filter((item) => item.type !== "All" && item.type !== "Empty");
      setCustomerTypes(filteredTypes);
      setTotalCount(AllCustomerData?.data?.type_counts?.[activeTab?.replace("#", "")]);
    }
  }, [AllCustomerData]);

  const memoizedCustomerData = useMemo(() => AllCustomerData?.data?.data, [AllCustomerData]);

  useEffect(() => {
    refetchHeader();
  }, [view]);

  const handleChangeView = (viewName) => {
    const tempView = viewList.filter((item) => item.view_name === viewName)[0];
    localStorage.setItem("saved_view", JSON.stringify(tempView));
    setView(tempView);
  };

  useEffect(() => {
    if (Object.keys(gridViewData || {})?.length) {
      // setListViewData(getListData(gridViewData));
      setColumnVisibility(getColumnVisibility(gridViewData, customerListHeader?.data.data));
    }
  }, [gridViewData]);

  const handleFieldVisibility = (field) => {
    const updatedData = updateFieldVisibility(gridViewData, field);
    setGridViewData(updatedData);
    setListViewData((prevData) => handleFieldVisibilityList(prevData, field));
  };

  const handleReorderFields = (sourceIndex, targetIndex) => {
    const updatedData = reorderVisibleFields(listViewData, sourceIndex, targetIndex);
    setListViewData(updatedData);

    setColumnOrder(["select", ...updatedData.visible_fields]);
  };

  useEffect(() => {
    if (location.key) {
      dispatch(getUserTokeData());
    }
  }, [location.key]);

  const [updateCustomerTableData, { CustomerDropLoad, CustomerDroperror }] = useUpdateCustomerTableDataNodeMutation();
  //post the task pod data
  const [
    createUpdateTask,
    {
      data: TaskPodData,
      isLoading: TaskPodLoading,
      isError: isTaskPodError,
      isSuccess: isTaskPodSuccess,
      error: TaskPodErrordata,
    },
  ] = usePostApiMutation();

  //post the task pod data useEffect
  useEffect(() => {
    //loading
    if (TaskPodLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (isTaskPodSuccess) {
      dispatch(
        pushAlert({
          message: TaskPodData?.message,
          type: TaskPodData.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );
      setSecondPopupOpen(false);
    }

    // catch block
    if (isTaskPodError) {
      dispatch(pushAlert({ message: TaskPodErrordata?.data?.message, type: "danger", visible: true }));
    }
  }, [isTaskPodSuccess, isTaskPodError, TaskPodLoading]);

  const customerTableFieldUpdate = async (item, field_name, cell, originalvalue) => {
    if (item === originalvalue) return; // If the value is the same, do not proceed with the update

    const customerIdArray = Object.keys(multiData || {}).length ? Object.keys(multiData || {}) : [field_name?.id];
    const updateData = {
      customer_id: customerIdArray,
      org_id: myUserDataParsed?.org_id,
      company_id: parsedCompanyData.company_id,
      field_name: cell?.column?.id,
      value: item,
    };

    try {
      setLoading(true);
      const result = await updateCustomerTableData({
        token: token,
        data: updateData,
      }).unwrap();
      setMultiData({});

      if (result?.success) {
        setLoading(false);

        refetchCustomerDataNode();
        dispatch(
          pushAlert({
            visible: true,
            message: "Data Updated Successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "Data Entry Error",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    timer = setInterval(() => {
      if (ticker > 0) setTicker((prevTick) => prevTick - 1);
    }, 1000);
    if (loading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    return () => clearTimeout(timer);
  }, [loading]);

  const handleExtraFieldAddHeader = async (fielddata, isUpdate) => {
    const payload = {
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      ...fielddata,
    };

    try {
      const result = await postFieldCreation({ payload, isUpdate: isUpdate ? true : false }).unwrap();
      if (result?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "success",
          })
        );

        refetchHeader();
        if (isUpdate) refetchCustomerDataNode();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setResetPageIndex(true);
  };

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const cursorloader = (loading || customerLoading || customerFetching) && freshPollingCounter.current === 0;

  useEffect(() => {
    if (cursorloader) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [cursorloader]);

  {
    /* useEffect(() => {
    if (cursorloader) {
      document.body.classList.add("cursor-waitload");
    } else {
      document.body.classList.remove("cursor-waitload");
    }

    return () => {
      document.body.classList.remove("cursor-waitload");
    };
  }, [cursorloader]); */
  }

  // const handleUpdateHeader ={

  // }

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery();

  const handleSubmitTask = async (data) => {
    const templateId = GetAlltemplates?.data?.find(
      (template) => template?.template_name?.toLowerCase() === data?.category_id?.toLowerCase()
    )?.id;

    const {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      end_date,
      update_entire_series,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
      ...RemFormData
    } = data;

    const recurrence = {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      end_date,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
    };

    const OnlyDynamicFields = { ...RemFormData, start_date, end_date };

    const payload = {
      row_id: taskId ? taskId?.id : null,
      template_id: data ? templateId : null,
      data: OnlyDynamicFields,
      // update_single_recurrence: !taskid?.recurModal ? true : false,
      // edit_entire_recurrence: taskid?.recurModal ? true : false,
    };
    if (data?.is_recurrence) {
      payload.recurrence = recurrence;
    }

    createUpdateTask({
      data: payload,
      url: `${NODE_URL}template/create-task`,
    });
  };

  const [isCustomerDrawer, setIsCustomerDrawer] = useState(false);
  const handleDrawerToggle = () => {
    setIsCustomerDrawer(false);
  };

  const handleAddCustomer = () => {
    setAddCustomerId("");
    setIsEditMode(true);
    setIsCustomerDrawer(true);
  };

  useEffect(() => {
    if (!isCustomerDrawer) {
      setIsHovered(false);
    }
  }, [isCustomerDrawer]);

  const handleArchived = () => {
    setIsArchived((prev) => !prev);
  };

  const handleCreateViewClick = () => {
    setIsCreateView(true);
    setMenuVisible(true);
    setShowViewList(false);
  };

  const [fieldDelete] = usePostFieldDeleteMutation();

  const handleFieldDelete = (field) => {
    if (!field || field.trim() === "") {
      dispatch(
        pushAlert({
          visible: true,
          message: "Field Name is Empty",
          type: "danger",
        })
      );
      return;
    }
    const payload = {
      company_id: getCompanyId(),
      field_name: field,
    };

    fieldDelete({ payload })
      .unwrap()
      .then((response) => {
        if (response?.success) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message || "Field Deleted Successfully",
              type: "success",
            })
          );
          refetchHeader();
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message || "Field Deletion Failed",
              type: "danger",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          pushAlert({
            visible: true,
            message: "Something went wrong",
            type: "danger",
          })
        );
      });
  };

  const CloseShowDetial = () => {
    setOpenShowDetails(false);
    setDetaillOpen(false);
  };
  const closePodModel = () => {
    setOpenModal(false);
  };

  //memoizing the options for portal list, since viewList changes infrequently, and we don't want to re re render unnecessarily

  const memoizedOptions = useMemo(() => {
    if (!viewList) return [];
    const hasMultiplePublicViews = viewList.filter((item) => item.view_access).length > 1;
    return viewList.map((option) => ({
      label: option.view_name,
      value: option.view_name,
      ...(hasMultiplePublicViews
        ? {
            toggleType: option.view_name !== "Default" && option.view_access ? "Public" : "Private",
          }
        : {}),
    }));
  }, [viewList]);

  const toggleButtons = useMemo(() => {
    if (!viewList) return [];
    return viewList.filter((item) => item.view_access).length > 1 ? ["Private", "Public"] : [];
  }, [viewList]);

  const selectedOptions = useMemo(() => {
    if (!viewList || !view) return [];
    return viewList
      .filter((item) => item.view_name === view.view_name)
      .map((option) => ({
        label: option.view_name,
        value: option.view_name,
        toggleType: option.view_name !== "Default" && option.view_access ? "Public" : "Private",
      }));
  }, [viewList, view]);

  //post in meta api function for updating the metadata of customer

  const [postMetaData, { isLoading: metaApiLoading }] = usePostMetaSaveMutation();

  const receiveMetaDataPayload = async (payload) => {
    const metaPayload = {
      view_name: view?.view_name,
      company_id: getCompanyId(),
      meta: {
        ...payload,
      },
    };

    const response = await postMetaData({ payload: metaPayload }).unwrap();

    return response;
  };

  return (
    <Fragment>
      <div className="px-2 py-2 h-full" id="innercontent">
        <div id="default-styled-tab-content" className="tablemaindiv h-full">
          <div className={`h-full `} id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
            <div className="h-full">
              <Fragment>
                {columns && memoizedCustomerData && (
                  <CustomerReactTable
                    headers={columns || []}
                    body={memoizedCustomerData || []}
                    tableDetail={{
                      // tableFilter: <TableLeadFilter />,
                      tableFilter: (
                        <ScrollableTabs
                          tabData={[{ type: "All" }, ...customerTypes]}
                          activeTab={activeTab}
                          handleTabClick={handleTabClick}
                        />
                      ),
                      tableName: "Customer",
                    }}
                    noMenuOpenList={["is_deletable", "select"]}
                    fetchPersonInTable={fetchPersonData}
                    rawHeaders={customerListHeader?.data?.data}
                    fetchtableBodyData={handleFetchOptionData}
                    customerCommnData={optionData}
                    refetchCustomerData={refetchCustomerDataNode}
                    TableFieldUpdate={customerTableFieldUpdate}
                    // metaPostData={postMetaData}
                    receiveMetaDataPayload={receiveMetaDataPayload}
                    isMetaApiCall
                    // isTaskPopupOpen={isTaskPopupOpen}
                    // setIsTaskPopupOpen={setIsTaskPopupOpen}
                    ExtraFields={
                      <div className="flex items-center justify-center gap-x-2 h-full">
                        <div
                          className={`group p-2 rounded-md cursor-pointer text-primary ${isArchived ? "bg-primary" : "bg-none"} hover:bg-[#F0F0F0]`}
                        >
                          <ToolTipComponent
                            disableInteractive
                            text={isArchived ? "Unarchive" : "Archive"}
                            textOnly={<>isArchived</>}
                            offset={"slightly-right"}
                            darkMode
                          >
                            <ArchiveIconNew
                              className={` ${isArchived ? "fill-[#F0F0F0]" : "fill-[#8E8E8E]"}  group-hover:fill-current`}
                              onClick={() => {
                                handleArchived();
                                setResetPageIndex(true);
                              }}
                            />
                          </ToolTipComponent>
                        </div>

                        {/* <ArchiveButton
                          isActive={isArchived}
                          onClick={() => {
                            handleArchived();
                            setResetPageIndex(true);
                          }}
                        /> */}

                        {/* <div className="flex items-center gap-2 cursor-pointer ">
                          <div
                            // className={`px-2 py-1 flex items-center justify-center border border-transparent  bg-FFFFFF hover:!border-[#1D4469] rounded-md `}
                            className={`px-2 py-1 flex items-center justify-center border border-transparent  bg-FFFFFF h-full hover:bg-[#CECECE4D] rounded-md`}
                            ref={ref}
                            onClick={() => setShowViewList(!showViewList)}
                          >
                            <button
                              className={` ${showViewList ? "text-[#1D4469] " : "text-[#848687] "} hover:text-[#1D4469] font-400 group text-sm justify-evenly  flex items-center gap-2 min-w-16 whitespace-nowrap`}
                            >
                              <span className="max-w-[10ch] min-w-[10ch] text-ellipsis overflow-hidden ">
                                {view?.view_name}{" "}
                              </span>
                              <DownArrow
                                fill={`${showViewList ? "#1D4469" : "#848687"} `}
                                className={`${showViewList ? "rotate-180" : "rotate-0"} group-hover:fill-[#1D4469]`}
                              />{" "}
                            </button> */}
                        <div className="flex items-center gap-2 cursor-pointer ">
                          <div
                            className="group"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <div
                              ref={ref}
                              onClick={() => setShowViewList(!showViewList)}
                              className={`flex h-full rounded-md overflow-hidden border-[#D2DAE1] cursor-pointer  border ${
                                isHovered || (showViewList && "border-[#D2DAE1]")
                              }`}
                            >
                              {/* Text area */}
                              {/* <div
                              className={`px-3 py-1 flex items-center transition-colors group-hover:bg-[#F1F6FB] ${
                                showViewList ? "" : ""
                              }`}
                            > */}
                              <div
                                className={`px-3 py-1 flex items-center 
                                       ${showViewList ? "bg-primary-hover" : "group-hover:bg-primary-hover"}`}
                              >
                                <span
                                  className={`text-sm font-500 whitespace-nowrap 
                                   ${showViewList ? "text-primary" : "text-[#848687] group-hover:text-primary"}`}
                                >
                                  {view?.view_name}
                                </span>
                              </div>
                              {/* Icon area (now also reacts to group hover) */}
                              <div className="px-3 py-1 flex items-center bg-white group-hover:bg-white text-primary">
                                <DownArrow
                                  className={`
                                  ${showViewList ? "rotate-180" : "rotate-0"} 
                                  fill-[#848687] group-hover:fill-current`}
                                />
                              </div>
                            </div>
                            <customerSeperateLine />
                          </div>
                          {showViewList && (
                            <>
                              <PortalList
                                open={showViewList}
                                onClose={() => setShowViewList(false)}
                                containerRef={ref}
                                width="150px"
                                // Pass all the stable, memoized props
                                options={memoizedOptions}
                                toggleButtons={toggleButtons}
                                selectedOptions={selectedOptions}
                                showSearch
                                onOptionClick={(data) => {
                                  handleChangeView(data[0].value);
                                  setShowViewList(false);
                                }}
                                noChildren
                                addButton
                                addButtonLabel="+ Create New View"
                                addButtonAction={handleCreateViewClick}
                              />
                            </>
                          )}
                        </div>

                        <div>
                          {isModalOpen && (
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                              <div className="bg-white p-5 rounded shadow-lg w-[530px]">
                                <div className="flex  justify-between border-b-2">
                                  <h2 className="text-16 font-500 mb-2 text-[#434852] ">Save as View</h2>
                                  <ClosePopUpIcn onClick={closeModal} />
                                </div>
                                <div className="pt-2">
                                  <h1 className="mb-1 text-[#434852] text-14 font-400">Name</h1>
                                  <input className="border-[#DFE2E5] w-[490px] pl-2 text-[#4F4F4F] text-12"></input>
                                </div>
                                <div className="sticky bottom-0 pt-4 flex justify-between  text-md w-full rounded-none z-[9998]">
                                  <div className="space-x-1 text-[#2999BC]">
                                    <input
                                      className="focus:outline-none focus:ring-0 border-[#2999BC] rounded-sm"
                                      type="checkbox"
                                      id="check1"
                                      name="check1"
                                      value="Bike"
                                    />
                                    <label for="check1"> Make It Public</label>
                                  </div>
                                  <div className="">
                                    <button
                                      onClick={closeModal}
                                      type="button"
                                      className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-normal px-5 py-1 text-center rounded-5px"
                                    >
                                      CANCEL
                                    </button>
                                    <button
                                      onClick={closeModal}
                                      type="submit"
                                      className="w-28 text-white bg-1D4469 hover:bg-20486F ok-btn font-normal border border-gray-200 py-1 px-5 ms-3 rounded-5px"
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    }
                    MainFields={
                      <div className="flex items-center justify-center gap-x-2">
                        <ToolTipComponent darkMode text="Manage View">
                          <span
                            onClick={handleMenuToggle}
                            className="cursor-pointer  border-[#EBF2F6] rounded-full hover:bg-[#F6F6F6] hover:border-transparent"
                          >
                            <ManageIcon isActive={menuVisible} isHovered={isMangeHovered} />
                          </span>
                        </ToolTipComponent>
                        {hasPermission && (
                          <ToolTipComponent darkMode text="Add Customer">
                            <span
                              onClick={handleAddCustomer}
                              className=" flex items-center justify-center cursor-pointer "
                            >
                              <AddItemPlus isActive={isCustomerDrawer} isHovered={isHovered} />
                            </span>
                          </ToolTipComponent>
                        )}
                      </div>
                    }
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    taskId={taskId}
                    isTaskDrawerOpen={isTaskDrawerOpen}
                    closeTaskDrawer={closeTaskDrawer}
                    taskClickCustomer={taskClickCustomer}
                    columnVisibility={columnVisibility}
                    setColumnVisibility={setColumnVisibility}
                    columnOrder={columnOrder}
                    setColumnOrder={setColumnOrder}
                    activeTab={activeTab}
                    view={view}
                    totalCount={totalCount}
                    multiData={multiData}
                    setMultiData={setMultiData}
                    resetPageIndex={resetPageIndex}
                    setResetPageIndex={setResetPageIndex}
                    grouping={grouping}
                    setGrouping={setGrouping}
                    handleReorderFields={handleReorderFields}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    excelDownload
                    leftPanel={true}
                    isAdvancedFilterOpen={isAdvancedFilterOpen}
                    setIsAdvancedFilterOpen={setIsAdvancedFilterOpen}
                    metaData={metaData}
                    refetchHeader={refetchHeader}
                    closeAdvancedFilter={closeAdvancedFilter}
                    // apiLoadingState={customerLoading}
                    selectedRowId={selectedRowId}
                    setSelectedRowId={setSelectedRowId}
                    apiStates={{
                      header: {
                        isLoading: headerLoading,
                        isError: headerError,
                      },
                      body: {
                        isLoading: customerLoading,
                        isError: customerError,
                      },
                    }}
                    sizingApiCall={true} //this is temporary, just for time being, till header api is not included in task table
                    alternateDivs={{
                      emptyData: (
                        <>
                          <div className="w-full h-full">
                            <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                              <NoCustomerData className="h-[300px] w-[300px]" />
                              <span className="text-14 text-[#666666] text-sm font-400 font-Inter ">
                                {isArchived ? "No archived customers found." : "No customers assigned."}
                              </span>
                            </div>
                          </div>
                        </>
                      ),
                    }}
                    dynamicScrollableTabs={true}
                    //props related to filter part,  will look into later to club them all
                    generateUniqueValues={generateUniqueValuesForCustomerPage}
                    useGenerateUniqueValues={true}
                    buildOptionsFromList={buildOptionsFromListCustomerPage}
                    useBuildOptionsFromList={true}
                  />
                )}
              </Fragment>
            </div>
          </div>
        </div>
      </div>

      {menuVisible && (
        <ManageViewDrawer
          thead={customerListHeader?.data.data}
          ExtraFieldAddHeader={handleExtraFieldAddHeader}
          setMenuVisible={setMenuVisible}
          menuVisible={menuVisible}
          isAddFieldOpen={isAddFieldOpen}
          setIsAddFieldOpen={setIsAddFieldOpen}
          view={view}
          handleChangeView={handleChangeView}
          viewList={viewList}
          gridViewData={gridViewData}
          listViewData={listViewData}
          handleFieldVisibility={handleFieldVisibility}
          refetchHeader={refetchHeader}
          setNewViewName={setNewViewName}
          handleReorderFields={handleReorderFields}
          isCreateView={isCreateView}
          fetchFieldOptions={handleFetchOptionData}
          fieldOptionsData={optionData}
          isSuccessOptions={isSuccessOptions}
          isErrorOptions={isErrorOptions}
          isFetchingOptions={isFetchingOptions}
          removeFieldApi={removeFieldApi}
        />
      )}

      {Boolean(viewNotesData) && (
        <ViewNotesDrawer
          Item={viewNotesData}
          isOpen={Boolean(viewNotesData)}
          handleCloseNotes={handleCloseNotes}
          refetch={refetchCustomerDataNode}
        />
      )}

      {isTaskDrawerOpen && (
        <TasListkModal
          isOpen={isTaskDrawerOpen}
          openSecondPopup={openSecondPopup}
          closePopup={closeTaskDrawer}
          customerId={taskClickCustomer?.id}
          secondPopupOpen={secondPopupOpen}
          leadTypeValue={leadTypeValue}
          isTaskPodSuccess={isTaskPodSuccess}
        />
      )}

      {console.log(secondPopupOpen, "secondPopupOpenvinay")}

      {secondPopupOpen && ( //vinay
        <DynamicAddTaskPodModal
          taskid={taskId}
          templateId={
            GetAlltemplates &&
            GetAlltemplates?.data?.find(
              (template) => template?.template_name?.toLowerCase() === leadTypeValue?.toLowerCase()
            )?.id
          }
          // templateId={taskList?.find((item) => item.label === leadTypeValue)?.id}
          isOpen={secondPopupOpen}
          closePopup={closeSecondPopup}
          onClose={closeSecondPopup}
          setAlert={setAlert}
          alert={alert}
          leadTypeValue={leadTypeValue}
          setLeadTypeValue={setLeadTypeValue}
          selectedCustomer={{
            customer_name: taskClickCustomer?.customer_name,
            customer_id: taskClickCustomer?.id,
            id: taskClickCustomer?.id,
          }}
          //firstPopupOpen={firstPopupOpen}
          refetch={refetchCustomerDataNode}
          setRefetchByTask={setRefetchByTask}
          // refetch={secondPopupOpen?.refetchTaskData}
          isDoubleComp={taskId?.recurModal}
          recurModal={taskId?.recurModal}
          activeModal={taskId?.activeModal}
          externalApi={{
            createUpdateTask: (data) => handleSubmitTask(data),
          }}
        />
      )}

      {isCustomerDrawer && (
        <CustomerInfoDrawer
          open={isCustomerDrawer}
          onClose={handleDrawerToggle}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          addCustomerId={addCustomerId}
          setAddCustomerId={setAddCustomerId}
          showMoreCustomerId={CustomerEditId}
          AddCustomer
          isDuplicate={isDuplicate}
          refetchCustomerDataNode={refetchCustomerDataNode}
        />
      )}

      {deleteCustomerOpen && (
        <DeleteDialogue
          openArchiveDialogue={deleteCustomerOpen}
          onClose={closeDeleteDrawer}
          rowData={CustomerDeleteId}
          refetch={refetchCustomerDataNode}
          multiData={multiData}
          setMultiData={setMultiData}
        />
      )}

      {archiveCustomerOpen && (
        <DeleteDialogue
          openArchiveDialogue={archiveCustomerOpen}
          onClose={closeArchiveDrawer}
          rowData={CustomerArchiveId}
          refetch={refetchCustomerDataNode}
          isArchive={true}
          multiData={multiData}
          setMultiData={setMultiData}
        />
      )}

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={handleConfirmDelete}
          onClose={() => {
            setShowConfirmation(false);
            setFieldToDelete(null);
          }}
          title="Drop Column Confirmation"
          // message={
          //   <>
          //     Are you sure you want to delete column - {""}
          //     <span className="font-semibold capitalize">{fieldToDelete?.replaceAll("_", " ")}</span> ?
          //   </>
          // }
          message={
            <div>
              You are about to remove a column from the <br /> data structure. This will result in permanent <br /> loss
              of all information stored in that column.
              <br />
              <span className="font-semibold capitalize">Do you want to proceed?</span>
            </div>
          }
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}

      {isTrackingDialogOpen && (
        <Dialog
          open={isTrackingDialogOpen}
          fullWidth
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              width: "800px",
            },
          }}
        >
          <CustomerOtherDetail custId={{ id: isTrackingDialogOpen }} onClose={closeTrackingDialog} />
        </Dialog>
      )}

      {(openShowDetails || detaillOpen) && (
        <CustomerShowDetails
          open={openShowDetails || detaillOpen}
          onClose={CloseShowDetial}
          Data={Data}
          setOpenModal={setOpenModal}
          setOpenShowDetails={setOpenShowDetails}
          setDetaillOpen={setDetaillOpen}
          enableEditButton={true}
        />
      )}

      {openModal && (
        <AddUserModal
          open={openModal}
          closePopup={closePodModel}
          title={SingleDelegation?.uuid ? "Edit User" : "Add User"}
          handelsave={() => {}}
          editData={SingleDelegation?.uuid}
          // isPermissionOpen={isPermissionOpen}
          // setIsPermissionOpen={setIsPermissionOpen}
        />
      )}
    </Fragment>
  );
};

export default LayoutHOC(Customer);
